import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import './deliverTo.scss';
import { abortOnGoingCallsFor, axiosConfig } from '../../../api/axios';
import FormRenderer from '../../../framework/Inputs/formRenderer/formRenderer';
import AddressFormate from '../../../framework/addressFormate/AddressFormate';
import { setDropdownValues, arrayToString, getDomesticAccounts } from '../../../utils/helperFunctions';
import { ServiceEndPoints } from '../../../utils/constants/ApiConstant';
import ClearanceDeclaration from '../../../container/shipment/addShipment/clearanceDeclaration/clearanceDeclaration';
import { getCustomDeclaration } from '../../../utils/utilsFunctions';
import * as actions from '../../../store/actions/index';
import { MISC_VALUES, DELIVER_TYPE } from '../../../utils/constants/constants';
import { useDebouncedCallback } from 'use-debounce';

const DeliverToSender = (props) => {
  const {
    formField: { toServiceRequired, specialInstructions, additionalInstruction },
    setFieldValue,
    formikValues,
    errors,
    servicePointAddress,
    updateValidationSchema,
    clearanceDecleration,
    populateClearance
  } = props;

  const allProducts = useSelector((state) => state.common.allProducts);
  const [services, setServices] = React.useState([]);
  const selectedAccount = useSelector((state) => state.accounts.selectedAccount);
  const userAccounts = useSelector((state) => state.accounts.nonReturnuserAccounts);
  const displayAccounts = getDomesticAccounts(userAccounts);
  const dispatch = useDispatch();



const fetchProducts = (params, dispatch, setServices) => {
  axiosConfig
    .get(params)
    .then((res) => {
      if (res.data.length > 0) {
        dispatch(actions.setAllAvailableProducts(res.data));
        let min = Math.min.apply(
          null,
          res.data.map((item) => item.sortOrder),
        );
        let minSortOrderData = res.data.find((services) => services.sortOrder === min);
        setServices(minSortOrderData?.deliveryCapabilities?.services || []);
      } else {
        dispatch(actions.setAllAvailableProducts([]));
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch(actions.setAllAvailableProducts([]));
      setServices([]);
    });
};

const debouncedFetchProducts = useDebouncedCallback(fetchProducts, 300); // Adjust the debounce delay as needed

useEffect(() => {
  if (formikValues.fromPostCode && formikValues.fromWeight) {
    const destinationAddressType =
      formikValues.deliveryType === DELIVER_TYPE.DELIVER_DOORSTEP
        ? DELIVER_TYPE.DOORSTEP
        : MISC_VALUES.SERVICE_POINT_HANDOVER_METHOD;

    const pickupAccount = `&pickupAccount=${selectedAccount?.accountId}`;
    abortOnGoingCallsFor(ServiceEndPoints.getProducts);
    const params = `${ServiceEndPoints.getProducts}DestinationPostalCode=${
      formikValues.returnType === 'returnToSender'
        ? selectedAccount?.sender?.postalCode
        : formikValues?.toPostCode
    }&DestinationCountryCode=GB&DestinationRecipientType=${
      formikValues.returnType === 'returnToSender' ? 'business' : formikValues.toAddressType
    }&weight=${formikValues?.fromWeight}&OriginPostalCode=${
      formikValues.fromPostCode
    }&OriginCountryCode=GB&parcels=${
      formikValues?.fromParcel
    }&destinationAddressType=${destinationAddressType}${pickupAccount}`;

    debouncedFetchProducts(params, dispatch, setServices);
  }
}, [
  selectedAccount,
  formikValues?.fromWeight,
  formikValues?.fromParcel,
  formikValues.returnType,
  formikValues?.toPostCode,
  formikValues.toAddressType,
  formikValues.deliveryType,
  formikValues.fromPostCode,
  formikValues.doorStepInstructions,
]);

  const loadedFrom = useSelector((state) => state.loadedFrom.loadedFrom);

  useEffect(() => {
    setFieldValue('toServiceRequired', setDropdownValues(services, 'name', 'Next day'));
  }, [services]);

  useEffect(() => {
    const loadedFromScreen = loadedFrom.loadedFrom;
    const loadedResponse = loadedFrom.loadedResponse;
    if (
      services?.length > 0 &&
      (loadedFromScreen === 'dropdownResponse' || loadedFromScreen === 'fromPreviewSummary') &&
      (loadedResponse || {}).service
    ) {
      const selectedService = setDropdownValues(services, 'name', loadedResponse.service?.description);
      setFieldValue('toServiceRequired', selectedService);
    }
  }, [services, loadedFrom]);

  const getDorStepInstructionsForParams = () => {
    const {
      DOORSTEP_ONLY,
      DELIVER_TO_NEIGHBOUR,
      NEIGHBOUR_DELIVERY,
      LEAVE_SAFE,
      SECURE_LOCATION_DELIVERY,
    } = MISC_VALUES;
    const DSI = formikValues?.doorStepInstructions;
    let instruction = DOORSTEP_ONLY;
    if (DSI?.value === DELIVER_TO_NEIGHBOUR) {
      instruction = NEIGHBOUR_DELIVERY;
    } else if (DSI?.value === LEAVE_SAFE) {
      instruction = SECURE_LOCATION_DELIVERY;
    }
    return instruction;
  };

  return (
    <Grid container item xs={12} sm={12} lg={12} spacing={3} style={{ paddingRight: 'unset' }}>
      <Grid item xs={12} style={{ paddingBottom: 'unset' }}>
        <b>Delivery address</b>
      </Grid>
      <AddressFormate
        addressType={
          selectedAccount.sender?.companyName ? MISC_VALUES.ACCOUNT_BUSINESS : MISC_VALUES.ACCOUNT_RESIDENTIAL
        }
        contactName={selectedAccount.sender?.name}
        businessName={selectedAccount.sender?.companyName}
        addressLine1={selectedAccount.sender?.address1}
        addressLine2={selectedAccount.sender?.address2}
        addressLine3={selectedAccount.sender?.address3}
        town={selectedAccount.sender?.city}
        country={selectedAccount.sender?.country}
        postCode={selectedAccount.sender?.postalCode}
        emailAddress={selectedAccount.sender?.email}
        telephoneNumber={selectedAccount.sender?.phone}
      />
      {allProducts && getCustomDeclaration(allProducts) && (
        <Grid item className="manager-outer-grid-clearance">
          <Grid container direction="row" spacing={1}>
            <Grid item>
              <b>Clearance Declaration</b>
            </Grid>
          </Grid>
          <Grid container direction="column" spacing={2} className="manage-width">
            <Grid item className="manager-inner-grid-clearance">
              <ClearanceDeclaration
                formField={props.formField}
                formikValues={formikValues}
                setFieldValue={setFieldValue}
                errors={errors}
                isDomestic={true}
                servicePointAddress={servicePointAddress}
                clearanceDecleration={clearanceDecleration}
                updateValidationSchema={updateValidationSchema}
                populateClearance={populateClearance}
                applyPadding={false}
                isCollectionRequest={true}
                isReturnToSender={true}
              />
            </Grid>
          </Grid>
          <br></br>
        </Grid>
      )}
      <Divider className="DividerLine" variant="middle" />
      <Grid container item xs={12} sm={12} lg={12} spacing={3}>
        <Grid item xs={12}>
          <b>Service details</b>
        </Grid>
        <Grid item xs={12}>
          <FormRenderer {...toServiceRequired.props} data={services} fullWidth />
        </Grid>
        <Grid item xs={12}>
          <FormRenderer {...specialInstructions.props} fullWidth />
        </Grid>
        <Grid item xs={12}>
          <FormRenderer {...additionalInstruction.props} label={'Additional instructions'} fullWidth />
        </Grid>
      </Grid>
    </Grid>
  );
};

DeliverToSender.propTypes = {
  formField: PropTypes.object,
  errors: PropTypes.object,
  formikValues: PropTypes.object,
  setFieldValue: PropTypes.func,
};

export default DeliverToSender;
